// elements to fade in on page load
const fadeInElements = document.querySelectorAll(".card");

// Create intersection observer with rootMargin to trigger 48px before entering viewport
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Use shorter delay for initial page load
        const delay = document.readyState === "complete" ? index * 100 : Math.min(50, index * 50);
        setTimeout(() => {
          entry.target.classList.add("fade-in-active");
        }, delay);
      }
    });
  },
  {
    rootMargin: "72px", // Trigger px before element enters viewport
    threshold: 0, // Trigger as soon as even one pixel is visible
  }
);

// Start observing after a brief initial delay
setTimeout(() => {
  fadeInElements.forEach((element) => {
    observer.observe(element);
    // Trigger initial check
    observer.unobserve(element);
    observer.observe(element);
  });
}, 10);
